import { observable, action, runInAction, reaction } from 'mobx'
import api from '../api'
import errorStore from './errorStore'
import translationStore from './translationStore'
import routingStore from './routingStore'

class PayoffStore {
  @observable type = ''
  @observable bankOwner = ''
  @observable bankIban = ''
  @observable bankBic = ''
  @observable paypalOwner = ''
  @observable paypalEmail = ''
  @observable amount = ''

  @observable typeMessage = ''
  @observable bankOwnerMessage = ''
  @observable bankIbanMessage = ''
  @observable bankBicMessage = ''
  @observable paypalOwnerMessage = ''
  @observable paypalEmailMessage = ''
  @observable amountMessage = ''

  @observable minimumAmount = undefined

  constructor() {
    this.getMinimumAmount()

    reaction(
      () => routingStore.location,
      () => this.resetStore(),
      { name: 'reset the payoffStore'}
    )
  }

  @action.bound setType(type) {
    this.type = type
  }

  @action.bound setBankOwner(bankOwner) {
    this.bankOwner = bankOwner
  }

  @action.bound setBankIban(bankIban) {
    this.bankIban = bankIban
  }

  @action.bound setBankBic(bankBic) {
    this.bankBic = bankBic
  }

  @action.bound setPaypalOwner(paypalOwner) {
    this.paypalOwner = paypalOwner
  }

  @action.bound setPaypalEmail(paypalEmail) {
    this.paypalEmail = paypalEmail
  }

  @action.bound setAmount(amount) {
    this.amount = amount
  }

  @action.bound setTypeMessage(typeMessage) {
    this.typeMessage = typeMessage
  }

  @action.bound setBankOwnerMessage(bankOwnerMessage) {
    this.bankOwnerMessage = bankOwnerMessage
  }

  @action.bound setBankIbanMessage(bankIbanMessage) {
    this.bankIbanMessage = bankIbanMessage
  }

  @action.bound setBankBicMessage(bankBicMessage) {
    this.bankBicMessage = bankBicMessage
  }

  @action.bound setPaypalOwnerMessage(paypalOwnerMessage) {
    this.paypalOwnerMessage = paypalOwnerMessage
  }

  @action.bound setPaypalEmailMessage(paypalEmailMessage) {
    this.paypalEmailMessage = paypalEmailMessage
  }

  @action.bound setAmountMessage(amountMessage) {
    this.amountMessage = amountMessage
  }

  @action.bound resetMessages() {
    this.typeMessage = ''
    this.bankOwnerMessage = ''
    this.bankIbanMessage = ''
    this.bankBicMessage = ''
    this.paypalOwnerMessage = ''
    this.paypalEmailMessage = ''
    this.amountMessage = ''
  }

  @action.bound async sendCashbackPayoff() {
    try {
      await api.User.postCashbackPayoff({
        type: this.type,
        bankOwner: this.bankOwner,
        bankIban: this.bankIban,
        bankBic: this.bankBic,
        paypalOwner: this.paypalOwner,
        paypalEmail: this.paypalEmail,
        amount: this.amount
      })

      return true
    } catch(error) {
    }
    return false
  }

  @action.bound async getMinimumAmount() {
    try {
      const response = await api.Config.getMinimumPayoffAmount()
      runInAction('get minimum amount', () => {
        this.minimumAmount = response.minimumPayoffAmount
      })
    } catch(error) {
      errorStore && errorStore.displayError(translationStore.translate(error.message))
    }
  }

  @action.bound resetStore() {
    this.type = ''
    this.bankOwner = ''
    this.bankIban = ''
    this.bankBic = ''
    this.paypalOwner = ''
    this.paypalEmail = ''
    this.amount = ''

    this.typeMessage = ''
    this.bankOwnerMessage = ''
    this.bankIbanMessage = ''
    this.bankBicMessage = ''
    this.paypalOwnerMessage = ''
    this.paypalEmailMessage = ''
    this.amountMessage = ''
  }
}

export default new PayoffStore()



// WEBPACK FOOTER //
// ./src/stores/payoffStore.js